import { NamedComplexEnum } from '../utils/complexEnum/NamedComplexEnum'
import { DetailedComplexEnumItem } from '../utils/complexEnum/DetailedComplexEnumItem'

const EarlyClosure = new DetailedComplexEnumItem({
  id: 'ED23A302-835E-41FF-814A-910A013E2E34',
  name: 'Early Closure',
  description: 'Immediately close a Field Design Change',
})

export type FDCConcurrenceLevelSideEffectItem = typeof EarlyClosure
type ID = FDCConcurrenceLevelSideEffectItem['id']
type Name = FDCConcurrenceLevelSideEffectItem['name']

class FDCConcurrenceLevelSideEffectEnum extends NamedComplexEnum<
  'FDCConcurrenceLevelSideEffect',
  FDCConcurrenceLevelSideEffectItem,
  Name,
  ID
> {
  readonly typename = 'FDCConcurrenceLevelSideEffect'
  /**
   * immediately close the FDC
   */
  EarlyClosure = EarlyClosure
  get values() {
    return [this.EarlyClosure]
  }
}

/**
 * FDC Concurrence Level Side Effects trigger as soon as a `FieldDesignChange` is
 * saved with a Concurrence Level, with a side effect
 */
export const FDCConcurrenceLevelSideEffect =
  new FDCConcurrenceLevelSideEffectEnum()
